import React, { useState, useEffect } from "react";
import Close from "../../../images/close-white.png";
import PropTypes from 'prop-types';

const ShowHideFromSearchModal = ({handleShowHidePost, loadingShowHidePost, isHidden}) => {
  ShowHideFromSearchModal.propTypes = {
    handleShowHidePost: PropTypes.func.isRequired,
    loadingShowHidePost: PropTypes.bool.isRequired,
    isHidden: PropTypes.bool.isRequired
  };

  return (
    <div
      className="modal fade"
      id="showHideFromSearchModal"
      tabIndex="-1"
      aria-labelledby="showHideFromSearchModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="showHideFromSearchModalLabel">
              Are you sure?
            </h5>

            <img
              src={Close}
              alt="close"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              width="50px"
              style={{ cursor: "pointer" }}
              id="showHideFromSearchModalClose"
            />
          </div>
          <div className="modal-body">
            <p style={{ marginBottom: 25 }}>
              {isHidden ? 'Do you want to include this post to search?' : 'Do you want to exclude this post from search?'}
            </p>
          </div>
          <div className="modal-footer border-0 p-2">
            <button type="button" className="btn" data-dismiss="modal">
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleShowHidePost(!isHidden)}
              style={{ width: 95 }}
            >
              {loadingShowHidePost ? (
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                "Yes"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShowHideFromSearchModal;
